import Valkyrie, { viSippy } from "@sippy-platform/valkyrie";

import { Box } from "@mui/material";
import PropTypes from "prop-types";

function EditorSidebar({ showForm, children }) {
  return (
    <Box
      sx={{
        ["@container (min-width: 800.1px)"]: {
          borderLeft: (theme) => `1px solid ${theme.vars.palette.divider}`,
        },
        ["@container (max-width: 800px)"]: {
          borderTop: (theme) => `1px solid ${theme.vars.palette.divider}`,
        },
        display: "flex",
      }}
    >
      {showForm ? (
        children
      ) : (
        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
            fontSize: 48,
            color: "grey.300",
            py: 5,
            ...theme.applyStyles("dark", {
              color: "grey.700",
            }),
          })}
        >
          <Valkyrie icon={viSippy} />
        </Box>
      )}
    </Box>
  );
}

EditorSidebar.propTypes = {
  showForm: PropTypes.bool,
  children: PropTypes.node,
};

export default EditorSidebar;
